package dev.moetz.chatoverlay.model

enum class EmoteProvider {
//    Twitch,
    SevenTV,
    BTTV,
    FFZ,
}